// What goes into a deployed package.
//
// A service is self-contained: `services/<id>/` holds its own source, its own `package.json`, and its own
// `node_modules`. That folder IS the package — nothing from the project root travels with it, which is what
// makes a service the same thing wherever it is checked out.

/**
 * Packed, but left out of the source hash.
 *
 * `node_modules` has to ship — the pod installs nothing — but hashing it would mean walking thousands of
 * generated files on every deploy to learn what the service's own `package-lock.json` already says.
 */
export const HASH_EXCLUDED_FOLDERS = [
  'node_modules',
]
